import React, { useState, useCallback, } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { components, } from 'styles';

export type ChildrenRenderProps = {
    open: boolean,
    handleClickOpen: () => void,
    handleClose: () => void,
    setOpen: (open: boolean) => void,
};

type Props = {
    children: (props: ChildrenRenderProps) => JSX.Element
};

type CookiesPolicy = {
    id: number,
    paragraph: string,
    paragraphs?: Array<CookiesPolicy>
};

const cookiesPolicy: Array<CookiesPolicy> = [
    {
        id: 1,
        paragraph: 'Serwis nie zbiera w sposób automatyczny żadnych informacji, z wyjątkiem informacji zawartych w plikach cookies.'
    },
    {
        id: 2,
        paragraph: 'Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.'
    },
    {
        id: 3,
        paragraph: 'Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu GWO.PL Gdańskie Wydawnictwo Oświatowe spółka z ograniczoną odpowiedzialnością spółka komandytowa z siedzibą pod adresem: Gdańsk, ul. Grunwaldzka 413.'
    },
    {
        id: 4,
        paragraph: 'Pliki cookies wykorzystywane są w celu:',
        paragraphs: [
            {
                id: 5,
                paragraph: 'dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji korzystania ze stron internetowych; w szczególności pliki te pozwalają rozpoznać urządzenie Użytkownika Serwisu i odpowiednio wyświetlić stronę internetową, dostosowaną do jego indywidualnych potrzeb;'
            }, {
                id: 6,
                paragraph: 'tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;'
            }, {
                id: 7,
                paragraph: 'utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;'
            }
        ]
    },
    {
        id: 8,
        paragraph: 'W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.'
    },
    {
        id: 9,
        paragraph: 'W ramach Serwisu stosowane są następujące rodzaje plików cookies:',
        paragraphs: [
            {
                id: 10,
                paragraph: '„niezbędne” pliki cookies, umożliwiające korzystanie z usług dostępnych w ramach Serwisu, np. uwierzytelniające pliki cookies wykorzystywane do usług wymagających uwierzytelniania w ramach Serwisu;'
            }, {
                id: 11,
                paragraph: 'pliki cookies służące do zapewnienia bezpieczeństwa, np. wykorzystywane do wykrywania nadużyć w zakresie uwierzytelniania w ramach Serwisu;'
            }, {
                id: 12,
                paragraph: '„funkcjonalne” pliki cookies, umożliwiające „zapamiętanie” wybranych przez Użytkownika ustawień i personalizację interfejsu Użytkownika, np. w zakresie wybranego języka lub regionu, z którego pochodzi Użytkownik, rozmiaru czcionki, wyglądu strony internetowej itp.;'
            }
        ]
    },
    {
        id: 13,
        paragraph: 'W wielu przypadkach oprogramowanie służące do przeglądania stron internetowych (przeglądarka internetowa) domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać w każdym czasie zmiany ustawień dotyczących plików cookies. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować automatyczną obsługę plików cookies w ustawieniach przeglądarki internetowej bądź informować o ich każdorazowym zamieszczeniu w urządzeniu Użytkownika Serwisu. Szczegółowe informacje o możliwości i sposobach obsługi plików cookies dostępne są w ustawieniach oprogramowania (przeglądarki internetowej).'
    },
    {
        id: 14,
        paragraph: 'Operator Serwisu informuje, że ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.'
    },
    {
        id: 15,
        paragraph: 'Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być również przez współpracujących z operatorem Serwisu reklamodawców oraz partnerów.'
    }
];

const CookieInfoDialog: React.FC<Props> = ({ children, }) => {
    const [ open, setOpen ] = useState(false);
    const dialogTitleClasses = components.makeDialogTitleStyles();
    const { list, subList, listItem, } = components.makeCookiesPolityListStyles();

    const handleClickOpen = useCallback(() => {
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const renderCookiesPolicy = useCallback(item => (
        <li key={item.id}
            className={listItem}>
            {item.paragraph}
            {item.paragraphs && <ul className={subList}>
                {item.paragraphs.map(
                    (subItem: CookiesPolicy) => (<li key={subItem.id}>{subItem.paragraph}</li>)
                )}
            </ul>}
        </li>
        ),
        [ listItem, subList, ]
    );

    const renderProps = {
        handleClickOpen,
        handleClose,
        setOpen,
        open,
    };

    return (
        <>
            {children(renderProps)}
            <Dialog fullWidth
                    maxWidth="sm"
                    open={open}
                    onClose={handleClose}>
                <DialogTitle classes={dialogTitleClasses}
                             disableTypography>
                    <Typography component="h4"
                                variant="h6">
                        Polityka wykorzystania plików Cookies
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <ul className={list}>
                            {cookiesPolicy.map(renderCookiesPolicy)}
                        </ul>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default CookieInfoDialog;
